import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "template-fields" };
const _hoisted_2 = { class: "template-fields__message" };
const _hoisted_3 = { class: "template-fields__items" };
const _hoisted_4 = ["for"];
const _hoisted_5 = ["id", "name", "onUpdate:modelValue", "onChange"];
const _hoisted_6 = { value: "0" };
const _hoisted_7 = ["value"];
const _hoisted_8 = ["onUpdate:modelValue", "placeholder"];
import { computed, nextTick, ref, watch } from 'vue';
const STATIC_VALUE = '0';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateFields',
    props: {
        connectorFields: {},
        columnOptions: {},
        initialConfig: {}
    },
    emits: ['update:fieldValues'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const selectedParamValue = ref([]);
        const dynamicFieldTemplateConfig = ref({
            templateId: '',
            fields: {},
        });
        const getFieldTemplate = computed(() => {
            return (props.connectorFields || []).find((field) => field.name === 'templateId');
        });
        const selectedTemplateFieldOption = computed(() => {
            const field = getFieldTemplate.value;
            if (!field || !field.options)
                return undefined;
            return field.options.find(option => option.id === field.defaultOption);
        });
        const templateMessage = computed(() => selectedTemplateFieldOption.value?.text || '');
        const paramKeys = computed(() => {
            const variables = templateMessage.value.match(/{{[^}]+}}/g) || [];
            const variableIds = variables.map(variable => variable.slice(2, -2).trim()).filter(Boolean);
            return Array.from(new Set(variableIds));
        });
        const isTemplateField = (index) => {
            const value = selectedParamValue.value[index];
            return !value || value === STATIC_VALUE;
        };
        let syncingFromProps = false;
        const hasConfigDiff = (nextConfig, initialConfig) => {
            if (!initialConfig)
                return false;
            if (nextConfig.templateId !== initialConfig.templateId) {
                return true;
            }
            const keys = new Set([...Object.keys(nextConfig.fields), ...Object.keys(initialConfig.fields)]);
            let hasDiff = false;
            keys.forEach(key => {
                if (hasDiff)
                    return;
                if (nextConfig.fields[key] !== initialConfig.fields[key]) {
                    hasDiff = true;
                }
            });
            return hasDiff;
        };
        const syncFromProps = () => {
            const templateId = selectedTemplateFieldOption.value?.id || props.initialConfig?.templateId || '';
            const keys = paramKeys.value;
            const existingFields = props.initialConfig?.fields || {};
            const fields = Object.fromEntries(keys.map(key => [key, existingFields[key] ?? '']));
            selectedParamValue.value = keys.map(key => {
                const value = fields[key];
                const dynamicMatch = value.match(/^{{(.+)}}$/);
                return dynamicMatch ? dynamicMatch[1] : STATIC_VALUE;
            });
            const nextConfig = {
                templateId,
                fields,
            };
            const shouldEmit = hasConfigDiff(nextConfig, props.initialConfig);
            syncingFromProps = true;
            dynamicFieldTemplateConfig.value = nextConfig;
            nextTick(() => {
                syncingFromProps = false;
                if (shouldEmit) {
                    emits('update:fieldValues', {
                        templateId: nextConfig.templateId,
                        fields: { ...nextConfig.fields },
                    });
                }
            });
        };
        watch([() => props.connectorFields, () => props.initialConfig, () => paramKeys.value], () => {
            syncFromProps();
        }, { immediate: true, deep: true });
        watch(() => dynamicFieldTemplateConfig.value, newValue => {
            if (syncingFromProps)
                return;
            emits('update:fieldValues', {
                templateId: newValue.templateId,
                fields: { ...newValue.fields },
            });
        }, { deep: true });
        const setFieldValue = (index, paramKey) => {
            dynamicFieldTemplateConfig.value.templateId = selectedTemplateFieldOption.value?.id || '';
            const selectedValue = selectedParamValue.value[index];
            if (!isTemplateField(index) && selectedValue) {
                dynamicFieldTemplateConfig.value.fields[paramKey] = `{{${selectedValue}}}`;
            }
            else {
                dynamicFieldTemplateConfig.value.fields[paramKey] = '';
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('audiences.integration-modal.message')) + ":", 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(templateMessage.value), 1),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paramKeys.value, (paramKey, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(['template-fields__subgroup', { 'template-fields__item--static': isTemplateField(index) }])
                        }, [
                            _createElementVNode("label", {
                                for: `select-${paramKey}`
                            }, _toDisplayString(_ctx.$t('audiences.integration-modal.parameter')) + " \"" + _toDisplayString(paramKey) + "\" ", 9, _hoisted_4),
                            _withDirectives(_createElementVNode("select", {
                                id: `select-${paramKey}`,
                                name: `select-${paramKey}`,
                                "onUpdate:modelValue": ($event) => ((selectedParamValue.value[index]) = $event),
                                onChange: ($event) => (setFieldValue(index, paramKey))
                            }, [
                                _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('audiences.integration-modal.static-value')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnOptions, (column) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: column.key,
                                        value: column.key
                                    }, _toDisplayString(column.name), 9, _hoisted_7));
                                }), 128))
                            ], 40, _hoisted_5), [
                                [_vModelSelect, selectedParamValue.value[index]]
                            ]),
                            (isTemplateField(index))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    "onUpdate:modelValue": ($event) => ((dynamicFieldTemplateConfig.value.fields[paramKey]) = $event),
                                    placeholder: _ctx.$t('audiences.integration-modal.enter-value')
                                }, null, 8, _hoisted_8)), [
                                    [_vModelText, dynamicFieldTemplateConfig.value.fields[paramKey]]
                                ])
                                : _createCommentVNode("", true)
                        ], 2));
                    }), 128))
                ])
            ]));
        };
    }
});
